
import { Component, Prop, Vue } from 'vue-property-decorator';
import VTable from '@/components/shared/table/VTable.vue';
import VEmptyState from '@/components/shared/VEmptyState.vue';
import HealthCheckFilter from '@/components/healthCheck/HealthCheckFilter.vue';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import { HealthCheck } from '@/interfaces/models/HealthCheck';
import { Venue } from '@/interfaces/models/Venue';
import { CustomerGroup as CustomerGroupEnum } from '@/enums/CustomerGroup';
import { HealthCheckType } from '@/enums/HealthCheckType';
import headers from './headers';

@Component({
  components: { VTable, VEmptyState, HealthCheckFilter },
})
export default class HealthCheckTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: HealthCheck[];
  @Prop({ type: Number, required: true }) public total!: number;
  @Prop({ type: Array, required: true }) public customerGroups!: CustomerGroupEnum[];
  @Prop({ type: Boolean, required: true }) public canEdit!: boolean;
  @Prop({ type: Boolean, required: true }) public canDelete!: boolean;
  @Prop({ type: Object, required: false }) public venue!: Venue;
  @Prop({ type: Array, required: true }) public venues!: Venue[];

  public headers: ColumnHeader[] = headers;

  public venueNames(venues: string[]) {
    if (!venues || venues.length === 0) {
      return '';
    }
    const names: Array<string | undefined> = this.venues.map((v: Venue) => {
      if (venues && venues!.indexOf(v._id) !== -1) {
        return v.name;
      }
    });

    return names.filter((n: string | undefined) => n !== undefined).join(', ');
  }

  public statusColor(status: HealthCheckType) {
    return status === HealthCheckType.SUCCESS ? 'green lighten-3' : 'red lighten-3';
  }
}
